import { schema } from 'normalizr'

import CommonTypeSchema from '../common-types/schema'

const CallBackSchema = new schema.Entity('callBacks', {
  product: CommonTypeSchema
})

export default CallBackSchema
